export default "__VITE_ASSET__BwrTiNj5__"